<template>
  <div class="gp-has-header text-left p-4">
    <mdb-card>
      <mdb-card-header class="primary-color text-white">
        <h5>Temporarily Unavailable</h5>
      </mdb-card-header>
      <mdb-card-body>
        <div v-if="settings.maintenanceMessage" v-html="settings.maintenanceMessage"></div>
        <div v-if="!settings.maintenanceMessage">
          We're sorry, but we are currently performing system maintenance. This usually lasts no more than 30 minutes.
        </div>
        <mdb-btn icon="recycle" @click="loadSettings">Check Status</mdb-btn>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbJumbotron,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbNavItem,
  mdbPopover,
  mdbRow,
  mdbView
} from 'mdbvue';
import activityFeed from './ActivityFeed'
import groupCard from './group/Card'
import api from '../services/groupsPlaceApi'
import explore from "./Explore";
import topAlerts from "./common/TopAlerts";
import EzumeePublicLanding from "./EzumeePublicLanding";
import GroupsPlacePublicLanding from "./GroupsPlacePublicLanding";
import SumatoPublicLanding from "./SumatoPublicLanding";

export default {
  name: 'Home',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbBadge,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbJumbotron,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbBtn,
    mdbView,
    mdbPopover,
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbInput,
    mdbMask,
    mdbNavbarBrand,
    mdbCardGroup,
    mdbListGroup,
    mdbListGroupItem,
    mdbIcon,
    activityFeed,
    groupCard,
    explore,
    topAlerts,
    EzumeePublicLanding,
    GroupsPlacePublicLanding,
    SumatoPublicLanding
  },
  computed: {
    executing() {
      return this.$store.state.executing
    },
    settings() {
      return this.$store.state.settings
    }
  },
  mounted() {
    //if (!this.settings.maintenanceMode) this.$router.push("/")
  },
  data() {
    return {
      refreshStatus: null
    }
  },
  methods: {
    loadSettings() {
      this.refreshStatus = null
      this.$store.dispatch("setExecuting", true)
      api.get("/public/settings").then(
        (results) => {
          this.$store.dispatch("setSettings", results.data)
          if (!results.data.maintenanceMode) {
            console.log("Results ", results.data)
            this.$router.push("/")
          }
          else this.$notify.error({ message: "Still unavailable. 😢 ", timeOut: 5000 })
        },
        (error) => {
          this.$notify.error({message: "Could not connect to the system server at this time.", timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>
